import Swal from 'sweetalert2';

import IconWarning from '../assets/images/icon-warning.png'
import IconError from '../assets/images/icon-error.png';
import IconSuccess from '../assets/images/icon-success.png';

export const showAlertMessage = async ({title = '', text = '', error = false}) => {
    const img = `<img src=${ error ? IconError : IconSuccess } class="swal-icon" alt="icon warning" />`;

    return Swal.fire({
        html: `<div class="swal-container-confirmation">
            <h1 class="swal-title">${title}</h1>
            <p class="swal-text">${text}</p>
            ${img}
        </div>`,
        showConfirmButton: false,
        showCancelButton: true,
        showCloseButton: false,
        reverseButtons: true,
        cancelButtonText: 'Cerrar',
        customClass: {
            cancelButton: "swal-confirm-button-confirmation",
        },
        backdrop: `rgba(228, 228, 228, 0.6)`
      })
}

export const showConfirmation = async ({title = '', text = '', icon = false, textConfirmButton = 'Sí, confirmar'}) => {
    const img = icon ? `<img src=${ IconWarning } class="swal-icon" alt="icon warning" />` : '';

    return Swal.fire({
        html: `<div class="swal-container-confirmation swal-container-confirmation--table">
            <h1 class="swal-title">${title}</h1>
            <p class="swal-text">${text}</p>
            ${img}
        </div>`,
        showCancelButton: true,
        showCloseButton: true,
        reverseButtons: true,
        confirmButtonText: textConfirmButton,
        cancelButtonText: 'Cancelar',
        customClass: {
            cancelButton: "swal-cancel-button-confirmation",
            confirmButton: "swal-confirm-button-confirmation"
        },
        backdrop: `rgba(228, 228, 228, 0.6)`
      })
}

export const showConfirmSaved = async ({title = '', text = '', icon = false, textConfirmButton = 'Sí, confirmar', showCloseButton = false}) => {
    const img = icon ? `<img src=${ IconWarning } class="swal-icon" alt="icon warning" />` : '';
    return Swal.fire({
        html: `<div class="swal-container-confirmation swal-container-confirmation--confirm-saved">
            <h1 class="swal-title swal-title--confirm-saved">${title}</h1>
            <p class="swal-text">${text}</p>
            ${img}
        </div>`,
        position: 'center-end',
        showCancelButton: true,
        showCloseButton,
        reverseButtons: true,
        confirmButtonText: textConfirmButton,
        cancelButtonText: 'Cancelar',
        customClass: {
            cancelButton: "swal-cancel-button-confirmation",
            confirmButton: "swal-confirm-button-confirmation"
        },
        backdrop: `rgba(228, 228, 228, 0.6)`
      })
}

export const showError = async ({ message, timer }) => {
    Swal.fire({
        html: `<div class="swal-container-error">
        <img src=${IconError} class="swal-icon" alt="red alert" />
        <p class="swal-text mb-0">${ message ? message : 'Ocurrió un error. Reinténtalo.'}</p>
        </div>`,
        timer: timer ? timer : 3000,
        showConfirmButton: false,
        background: 'hsla(0, 0%, 77%, 0)',
        backdrop: true,
        position: 'top-end',
        width: 0
    });
}


export const showSuccess = async ({ message, timer }) => {
    Swal.fire({
        html: `<div class="swal-container-success">
        <img src=${IconSuccess} class="swal-icon" alt="green check" />
        <p class="swal-text mb-0">${ message ? message : 'Se completó la tarea con éxito.'}</p>
        </div>`,
        timer: timer ? timer : 3000,
        showConfirmButton: false,
        background: 'hsla(0, 0%, 77%, 0)',
        backdrop: true,
        position: 'top-end',
        width: 0
    });
}